import { useMemo } from "react";
import styled from "styled-components";

import * as UI from "../../../../../../modules/ui-kit";

export default function UnitSelection(props) {
    const { disabled, onChange, parameter, unit } = props;

    const propertyHasValidUnit = parameter.units?.includes?.(unit);

    const options = useMemo(
        () => {
            const units = parameter.units?.slice?.() ?? [];
            if (!propertyHasValidUnit && unit) {
                units.push(unit);
            }
            return units.sort().map((x) => ({ label: x, value: x }));
        },
        [parameter.units, propertyHasValidUnit, unit],
    );

    const parameterHasUnits = parameter.units?.length > 0;
    if (!parameterHasUnits) return undefined;

    return (
        <Select
            isDisabled={ disabled || (options.length === 1 && unit === options[0].value) }
            isOptionDisabled={ (option) => !propertyHasValidUnit && option.value === unit }
            onSelect={ onChange }
            options={ options }
            value={ unit }
        />
    );
}

const Select = styled(UI.Select)`
    min-width: 100px;
`;
